import { doc, getDoc, setDoc, getDocs, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../firebaseConfig";

// The id of the shared materials doc a job's materials live in.
// - A brand new / recurring job uses its own id (nothing to link to).
// - A job created via "Continue" or a Project's "next day" carries forward
//   materialsGroupId from the job it came from, so the whole chain reads
//   and writes the same shared materials list.
export const getMaterialsGroupId = (job = {}) =>
  String(job.materialsGroupId || job.id || "");

// Fetch every job_materials doc at once (for list/tile views), keyed by
// materialsGroupId -> materials array.
export const fetchAllJobMaterials = async () => {
  const snap = await getDocs(collection(db, "job_materials"));
  const map = {};
  snap.forEach((d) => {
    const data = d.data();
    map[d.id] = Array.isArray(data.materials) ? data.materials : [];
  });
  return map;
};

// Load the materials for a single job. If this job's shared materials doc
// doesn't exist yet, fall back to (and migrate) whatever was previously
// stored directly on the job at job.jobPlan.materials, so existing jobs
// don't lose their materials the first time they're opened after this change.
export const loadMaterialsForJob = async (job) => {
  const groupId = getMaterialsGroupId(job);
  if (!groupId) return [];

  const snap = await getDoc(doc(db, "job_materials", groupId));
  if (snap.exists()) {
    const data = snap.data();
    return Array.isArray(data.materials) ? data.materials : [];
  }

  const legacyMaterials = Array.isArray(job?.jobPlan?.materials)
    ? job.jobPlan.materials
    : [];

  if (legacyMaterials.length > 0) {
    await setDoc(
      doc(db, "job_materials", groupId),
      { materials: legacyMaterials, updatedAt: serverTimestamp() },
      { merge: true }
    );
  }

  return legacyMaterials;
};

// Save the full materials list for a job's shared materials group.
export const saveMaterialsForJob = async (job, materials) => {
  const groupId = getMaterialsGroupId(job);
  if (!groupId) return;

  await setDoc(
    doc(db, "job_materials", groupId),
    { materials, updatedAt: serverTimestamp() },
    { merge: true }
  );
};
